import { CaseState } from 'app/area/case/types-store';
import get from 'lodash/get';
import { ComplexValue } from 'ui';

export const expandComplexValueProp = (valueName: string, minLevelName: string, propName: string) => 
  (state: CaseState, uiEngineProps: any) => {

  const complexValue = get(uiEngineProps, propName) as ComplexValue<any>;
  
  return { 
    [valueName]: complexValue && complexValue.value,
    [minLevelName]: complexValue && complexValue.minLevel
  };
};
